export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20editorial%20composition%20with%20deep%20crimson%20and%20warm%20amber%20tones%2C%20layered%20geometric%20shapes%20suggesting%20breaking%20news%20and%20digital%20media%20flow%2C%20sophisticated%20magazine%20style%20background%20with%20subtle%20texture%20overlays%2C%20dramatic%20lighting%20creating%20depth%2C%20dark%20atmospheric%20elements%20contrasting%20with%20warm%20highlights%2C%20contemporary%20gallery%20art%20representing%20information%20flow%20in%20digital%20age&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
          alt="五一黑料网 - 全网最热黑料吃瓜内容平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative w-full z-10 px-4 md:px-6 py-20 md:py-24">
        <div className="w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-sm font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-fill"></i>
              实时更新 · 每日爆料
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] font-black text-background-50 leading-tight mb-4 tracking-tight">
              五一黑料网
              <span className="block text-accent-400 text-2xl sm:text-3xl md:text-4xl lg:text-[2.4rem] font-bold mt-1">
                全网最热黑料吃瓜第一站
              </span>
            </h1>

            <p className="text-lg md:text-xl text-accent-300 font-medium mb-6">
              最新爆料 · 深度内幕 · 实时吃瓜，一站掌握
            </p>

            <p className="text-sm md:text-base text-background-50/75 leading-relaxed mb-8 max-w-[620px] lg:max-w-none">
              五一黑料网专注全网黑料吃瓜内容聚合，每日追踪各大平台最新爆料与内幕事件。
              覆盖娱乐圈、网红圈、商业圈等多领域热点瓜，以最快速度呈现瓜田爆料与吃瓜事件合集。
              无论是今日黑料还是历史大瓜，这里都有最全的实时吃瓜视频和深度梳理，让你不错过任何一个热点。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-black text-accent-400 font-heading">100+</span>
                <span className="text-xs md:text-sm text-background-50/65">每日新增爆料</span>
              </div>
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-black text-accent-400 font-heading">50+</span>
                <span className="text-xs md:text-sm text-background-50/65">覆盖平台数</span>
              </div>
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-black text-accent-400 font-heading">7×24h</span>
                <span className="text-xs md:text-sm text-background-50/65">全天候追踪</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-bold rounded-full text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
              >
                <i className="ri-fire-fill"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full text-base border border-background-50/25 hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20collage%20with%20layered%20media%20fragments%20and%20bold%20typography%20elements%2C%20warm%20crimson%20and%20deep%20charcoal%20color%20palette%2C%20dynamic%20diagonal%20composition%20suggesting%20breaking%20news%20energy%2C%20abstract%20geometric%20shapes%20overlapping%20with%20newspaper%20texture%2C%20modern%20magazine%20art%20direction%20style%2C%20high%20contrast%20dramatic%20lighting&width=800&height=600&seq=hero-visual-right&orientation=landscape"
                alt="五一黑料网实时爆料热点追踪"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-900/30 via-transparent to-accent-500/20 rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}